"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphQLClient = exports.ClientError = void 0;
var tslib_1 = require("tslib");
var http_client_1 = require("@wix/http-client");
var ClientError = /** @class */ (function (_super) {
    tslib_1.__extends(ClientError, _super);
    function ClientError(response, request) {
        var _this = this;
        var message = "".concat(ClientError.extractMessage(response), ": ").concat(JSON.stringify({
            response: response,
            request: request,
        }));
        _this = _super.call(this, message) || this;
        _this.response = response;
        _this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, ClientError);
        }
        return _this;
    }
    ClientError.extractMessage = function (response) {
        try {
            return response.errors[0].message;
        }
        catch (e) {
            return "GraphQL Error (Code: ".concat(response.status, ")");
        }
    };
    return ClientError;
}(Error));
exports.ClientError = ClientError;
var Batcher = /** @class */ (function () {
    function Batcher(flush) {
        this.flush = flush;
        this.buffer = [];
        this.timeout = null;
    }
    Batcher.prototype.batch = function (data) {
        var _this = this;
        if (this.timeout === null) {
            this.timeout = setTimeout(function () {
                _this.flush(_this.buffer);
                _this.buffer = [];
                _this.timeout = null;
            }, 0);
        }
        this.buffer.push(data);
    };
    return Batcher;
}());
var GraphQLClient = /** @class */ (function () {
    function GraphQLClient(baseURL, options) {
        var _this = this;
        this.makeRequest = function (batchedData) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var headers, payload, oneQuery, body, response_1, data, results, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = this.options.headers;
                        payload = batchedData.map(function (d) { return d.data; });
                        oneQuery = payload.length === 1;
                        body = oneQuery ? payload[0] : payload;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.httpClient.post('/', body, {
                                headers: headers,
                            })];
                    case 2:
                        response_1 = _a.sent();
                        data = response_1.data;
                        results = oneQuery ? [data] : data;
                        results.forEach(function (result, ind) {
                            var batchedD = batchedData[ind];
                            if (response_1.status === 200 && !result.errors && result.data) {
                                // batchedD.resolve({ ...result, headers, status });
                                batchedD.resolve(result.data);
                            }
                            else {
                                var errorResult = typeof result === 'string' ? { error: result } : result;
                                batchedD.reject(new ClientError(tslib_1.__assign(tslib_1.__assign({}, errorResult), { status: response_1.status, headers: response_1.headers }), {
                                    query: batchedD.data.query,
                                    variables: batchedD.data.variables,
                                }));
                            }
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        batchedData.map(function (b) { return b.reject(e_1); });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.options = options || {};
        this.batcher = new Batcher(this.makeRequest);
        this.httpClient = new http_client_1.HttpClient({
            baseURL: baseURL,
        });
    }
    GraphQLClient.prototype.request = function (query, variables) {
        var resolve, reject;
        var promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        var data = {
            query: query,
            variables: variables ? variables : undefined,
        };
        this.batcher.batch({ data: data, resolve: resolve, reject: reject });
        return promise;
    };
    GraphQLClient.prototype.setHeaders = function (headers) {
        this.options.headers = headers;
        return this;
    };
    GraphQLClient.prototype.setHeader = function (key, value) {
        var _a;
        var headers = this.options.headers;
        if (headers) {
            headers[key] = value;
        }
        else {
            this.options.headers = (_a = {}, _a[key] = value, _a);
        }
        return this;
    };
    return GraphQLClient;
}());
exports.GraphQLClient = GraphQLClient;
//# sourceMappingURL=request.js.map